import Alpine from 'alpinejs'

/**
 * dispatches:
 * - variant-selection-requested
 * - show-add-to-cart-confirmation {
 *      item: item  
 *   }
 */
Alpine.data('addToCart', (config, variants, jewelryBoxDefaultVariantId, jewelryBoxPresentVariantId, queryString='') => ({

    config: config,
    variants: variants,
    jewelryBoxDefaultVariantId: jewelryBoxDefaultVariantId,
    jewelryBoxPresentVariantId: jewelryBoxPresentVariantId,
    
    errorMessage: null,
    selectedVariantId: null,
    autoAddToCartOnVariantSelected: false,
    lockButton: false,

    jewelryBoxDefaultSelected: false,
    jewelryBoxPresentSelected: false,
    
    init() {
        this.$watch('selectedVariantId', variantId => {
            if(variantId && this.autoAddToCartOnVariantSelected) {
                this.addToCart()
            }
        })
    },
    
    async addToCart() {

        this.errorMessage = null
        if(!this.selectedVariantId) {
            this.$dispatch('variant-selection-requested')
            this.autoAddToCartOnVariantSelected = true
            return
        }
        this.autoAddToCartOnVariantSelected = false
        const variant = this.variants.find(variant => variant.variantId === this.selectedVariantId)
        if(!variant) {
            return
        }
        
        this.lockButton = true
        try {
            // add via cart-store
            
            const item = await Alpine.store('cart').addProduct(
                variant.addToCartUrlTemplate+queryString, 
                variant.productId,
                variant.variantId
            )
            if(!item) {
                this.lockButton = false
                return
            }

            this.$dispatch('show-add-to-cart-confirmation', {
                item: item
            })
            
            // add jewelry boxes, if selected
            
            if(this.jewelryBoxDefaultSelected && this.jewelryBoxDefaultVariantId) {
                const upsellItem = item.upsellProducts.find(upsellItem => upsellItem.variantId === this.jewelryBoxDefaultVariantId)
                if(upsellItem) {
                    await Alpine.store('cart').addProduct(
                        upsellItem.addToCartUrlTemplate,
                        upsellItem.productId,
                        upsellItem.variantId
                    )
                    this.jewelryBoxDefaultSelected = false
                }
            }
            
            if(this.jewelryBoxPresentSelected && this.jewelryBoxPresentVariantId) {
                const upsellItem = item.upsellProducts.find(upsellItem => upsellItem.variantId === this.jewelryBoxPresentVariantId)
                if(upsellItem) {
                    await Alpine.store('cart').addProduct(
                        upsellItem.addToCartUrlTemplate,
                        upsellItem.productId,
                        upsellItem.variantId
                    )
                    this.jewelryBoxPresentSelected = false
                }
            }
            
        } catch {
            alert(this.config.errorMessage)
        }
        this.lockButton = false
    },
    
}));